<template>
  <settings-modal
    class="t-link-esim-fee-modal"
  >
    <template slot="heading">Link E-Sim fee</template>

    <div>Are you sure you want to link payment: {{ refundPaymentId }}?</div>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        class="t-confirm-button"
        flat
        :disabled="loading"
        @click="onLinkPaymentButtonClick"
      >Link payment</v-btn>

      <v-btn
        color="light-blue darken-3"
        class="t-cancel-button"
        flat
        @click="onCancelButtonClick"
      >Cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import EsimApi from '@/services/Api/EsimApi'

  // Mixins
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'LinkEsimFeeModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [flashMessages],
    data () {
      return {
        linkEsimFeeApi: new ApiRequest(EsimApi.linkEsimFee)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      refundPaymentId () {
        return this.modal.data.refundPaymentId
      },
      orderId () {
        return this.modal.data.orderId
      },
      loading () {
        return this.linkEsimFeeApi.loading
      },
      error () {
        return this.linkEsimFeeApi.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onLinkPaymentButtonClick () {
        this.linkEsimFeeApi
          .execute({
            refundPaymentId: this.refundPaymentId,
            orderId: this.orderId
          })
          .then(this.linkEsimFeeSuccess)
          .catch(() => this.showErrorFlashMessage('E-sim fee link failed'))
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      linkEsimFeeSuccess () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.showSuccessFlashMessage(`Link for e-Sim fee ${this.refundPaymentId} successfully`)
      }
    }
  }
</script>
